import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import savedConfigsService from '../services/savedConfigsService';

export default function PublicConfigsDialog({ open, onClose, onLoad, isManager, onDelete, onClone }) {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      loadPublicConfigs();
    }
  }, [open]);

  const loadPublicConfigs = async () => {
    setLoading(true);
    try {
      const publicConfigs = await savedConfigsService.getPublicConfigs();
      setConfigs(publicConfigs);
    } catch (error) {
      console.error('Error loading public configs:', error);
      setConfigs([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Public Configurations</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress />
          </Box>
        ) : configs.length === 0 ? (
          <Typography>No public configurations available.</Typography>
        ) : (
          <List>
            {configs.map(cfg => (
              <ListItem key={cfg.id} secondaryAction={
                <>
                  {!isManager && onClone && (
                    <Button onClick={() => onClone(cfg)} sx={{ mr: 1 }}>Clone</Button>
                  )}
                  {isManager && onDelete ? (
                    <IconButton edge="end" onClick={() => onDelete(cfg.id)}>
                      <DeleteIcon />
                    </IconButton>
                  ) : null}
                </>
              }>
                <ListItemText
                  primary={cfg.name}
                  secondary={
                    <Box>
                      <Typography variant="caption">
                        Type: {cfg.cableType} | By: {cfg.createdBy} | Created: {new Date(cfg.createdAt).toLocaleString()}
                        {cfg.accessCount > 0 && ` | Accessed: ${cfg.accessCount} times`}
                      </Typography>
                    </Box>
                  }
                />
                <Button onClick={() => onLoad(cfg.id)} sx={{ ml: 2 }}>Load</Button>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
} 